import React, { Component } from 'react';
import { QuizActions } from 'actions';
import { mixin, RefluxMixin } from 'Util';
import { QuizStore } from 'stores';
import { Task, TaskResultList, RadioTaskResult } from 'components/Route/Task';
import AuthStore from 'stores/Auth';
import { RaisedButton, FloatingActionButton } from 'material-ui';
import { history } from 'helpers';

import moment from 'moment';
import {
  NavigationArrowForward,
  NavigationArrowBack,
  HardwareKeyboardArrowRight
} from 'components/Material/SvgIcons';
import { translate as _l } from 'oxygen-i18n';
import { Colors } from 'Css';
import Confetti from './Confetti';

addTranslations({
  'en-US': {
    'Your score': 'Your score',
    comment: 'Question feedback',
    'Quiz Finnished tooltip': 'When did the user end the quiz',
    Finnished: 'Finished',
    'Quiz status tooltip': 'Did the user pass or fail the quiz',
    Status: 'Status',
    Score: 'Score',
    'Total tooltip': 'Total amount of points',
    Total: 'Total',
    'Duration tooltip': 'Time to complete the test',
    Duration: 'Duration',
    'Welcome': 'Welcome',
    Result: 'Previous result',
    Restart: 'Retake the Quiz',
    'End test': 'End Quiz',
    Questions: 'Questions'
  },
  'sv-SE': {
    'Your score': 'Din poäng',
    comment: 'Kommentar till svar',
    'Quiz Finnished tooltip': 'När avslutades quizen',
    Finnished: 'Sluttid',
    'Quiz status tooltip': 'Klarade användaren quizen?',
    Status: 'Status',
    Score: 'Poäng',
    'Total tooltip': 'Totalt antal poäng',
    Total: 'Total',
    'Duration tooltip': 'Hur lång tid tog quizen',
    Duration: 'Tidsåtgång',
    'Welcome': 'Välkommen',
    Result: 'Tidigare resultat',
    Restart: 'Gör om Quizen',
    'End test': 'Avsluta Quiz',
    Questions: 'Frågor'
  }
});

const styles = {
  startButtonContainer: {
    left: '50%',
    position: 'relative',
    transform: 'translateX(-50%)',
    display: 'inline-block'
  },
  startButton: {
    marginRight: '5px'
  },
  navButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)'
  },
  paginationBlock: {
    padding: 5,
    marginRight: 10,
    marginTop: 10,
    minWidth: 58,
    border: 0
  }
};

const classes = oxygenCss({
  container: {
    position: 'relative'
  },
  message: {
    textAlign: 'center',
    whiteSpace: 'pre-wrap'
  },
  startButton: {
    float: 'right'
  },
  hideButtons: {
    '@media only screen and (max-width: 480px)': {
      display: 'none!important'
    }
  },
  pagination: {
    marginTop: '20%'
  },
  paginationDivider: {
    borderStyle: 'none none solid none',
    borderColor: Colors.text.Dark.divider,
    borderWidth: 1,
    textAlign: 'center',
    marginBottom: '10px'
  },
  comment: {
    marginLeft: '10px',
    background: '#fff0cb',
    padding: '5px 10px',
    width: 'calc(100% - 40px)'
  },
  confetti: {
    height: '100%',
    width: '100%',
    position: 'fixed',
    top: '0',
    left: '0',
    right: '0',
    bottom: '0',
    zIndex: '-1'
  }
});

function dateCheck(from, to, check) {
  let fDate, lDate, cDate;
  fDate = Date.parse(from);
  lDate = Date.parse(to);
  cDate = Date.parse(check);

  if (cDate <= lDate && cDate >= fDate) {
    return true;
  }
  return false;
}

class QuizContainer extends mixin(RefluxMixin, Component) {
  listenToStores() {
    this.listenToStore(QuizStore);
    this.listenToStore(AuthStore, 'auth');
  }

  componentWillReceiveProps(nextProps) {
    history.listenBefore((_, callback) => {
      if (this.state.started && !this.state.ended) {
        alert("Do not leave the test! If you do your results won't be saved");
        callback(false);
      } else {
        callback(true);
      }
    });
    if (!this.state.startTime) {
      QuizActions.initialize(
        nextProps.data,
        nextProps.quizSettings,
        nextProps.pageId,
        nextProps.userdata
      );
    }
  }

  componentDidMount() {
    QuizActions.initialize(
      this.props.data,
      this.props.quizSettings,
      this.props.pageId,
      this.props.userdata
    );
  }

  componentWillUnmount() {
    QuizActions.reset();
  }

  render() {
    return <QuizPage {...this.props} {...this.state} />;
  }
}

//just for show
class QuizPage extends Component {
  render() {
    const {
      currentStep,
      content,
      themeColor,
      currentQuestion,
      answers,
      score,
      threshold,
      userdata,
      testComplete,
      quizSettings,
      displayNext,
      displayPrev,
      pageId,
      time
    } = this.props;
    const hasTaken =
      userdata.pages &&
      userdata.pages[pageId] &&
      !!userdata.pages[pageId].length;
    let prevResult = {};
    if (hasTaken) {
      prevResult = userdata.pages[pageId];
      if (hasTaken && userdata.locked && !quizSettings.repeatable) {
        const data = userdata.pages[pageId][userdata.pages[pageId].length - 1];

        return (
          <div>
            <QuizResult
              title={
                data.status === 'QUIZ_SUCCESS'
                  ? quizSettings.successText
                  : quizSettings.failText
              }
              hide={quizSettings.hideAnswers || false}
              data={prevResult}
              themeColor={themeColor}
              score={data.score}
              total={Object.keys(answers).length || data.total}
              threshold={threshold}
              currentStep={currentStep}
              content={content}
            />
          </div>
        );
      }

      if (
        hasTaken &&
        !userdata.locked &&
        !quizSettings.repeatable &&
        currentStep === 'QUIZ_RESULT'
      ) {
        const data = userdata.pages[pageId][0];
        return (
          <div>
            <QuizResult
              title={
                data.status === 'QUIZ_SUCCESS'
                  ? quizSettings.successText
                  : quizSettings.failText
              }
              hide={quizSettings.hideAnswers || false}
              data={prevResult}
              themeColor={themeColor}
              score={data.score}
              total={Object.keys(answers).length || data.total}
              threshold={threshold}
              currentStep={currentStep}
              content={content}
              enableRestartQuiz={true}
            />
          </div>
        );
      }
    }

    switch (currentStep) {
      case 'QUIZ_INTRO':
        return (
          <QuizMessage
            title={_l`Welcome`}
            description={quizSettings.descriptionText || ''}
            settings={quizSettings}
            themeColor={themeColor}
            currentStep={currentStep}
            content={content}
            result={this.props}
            hasPreviewsResult={hasTaken}
          />
        );
      case 'QUIZ_MAIN':
        return (
          <QuizInteractionModule
            time={time}
            displayNext={displayNext}
            displayPrev={displayPrev}
            currentQuestion={currentQuestion}
            themeColor={themeColor}
            currentStep={currentStep}
            testComplete={testComplete}
            content={content}
          />
        );
      case 'QUIZ_FAIL':
        return (
          <QuizResult
            hide={quizSettings.hideAnswers || false}
            title={quizSettings.failText}
            score={score}
            total={Object.keys(answers).length}
            threshold={threshold}
            themeColor={themeColor}
            currentStep={currentStep}
            content={content}
            data={prevResult || {}}
            enableRestartQuiz={quizSettings.repeatable}
          />
        );
      case 'QUIZ_SUCCESS':
        return (
          <QuizResult
            hide={quizSettings.hideAnswers || false}
            title={quizSettings.successText}
            Confetti={Confetti}
            themeColor={themeColor}
            score={score}
            total={Object.keys(answers).length}
            threshold={threshold}
            currentStep={currentStep}
            content={content}
            data={prevResult || {}}
            enableRestartQuiz={quizSettings.repeatable}
          />
        );
      case 'QUIZ_RESULT':
        const page = this.props.userdata.pages[pageId];
        let lastestScore = page && page[page.length - 1].score;
        let latestTotal = page && page[page.length - 1].total;
        let latestTitle =
          page && page[page.length - 1].status === 'QUIZ_SUCCESS'
            ? quizSettings.successText
            : quizSettings.failText;
        return (
          <QuizResult
            hide={quizSettings.hideAnswers || false}
            score={lastestScore}
            title={latestTitle}
            total={latestTotal}
            threshold={threshold}
            themeColor={themeColor}
            currentStep={currentStep}
            data={prevResult || {}}
            content={content}
            enableRestartQuiz={quizSettings.repeatable}
          />
        );
      default:
        return <div />;
    }
  }
}

class QuizInteractionModule extends Component {
  next() {
    QuizActions.next();
  }

  prev() {
    QuizActions.prev();
  }

  render() {
    const {
      themeColor,
      currentQuestion,
      content,
      displayNext,
      testComplete,
      displayPrev,
      time
    } = this.props;
    const { taskResults, pageModuleId, ...task } = content[currentQuestion];
    return (
      <div>
        <p style={{ textAlign: 'center' }}>{time}</p>
        <section className={classes.container}>
          <FloatingActionButton
            className={classes.hideButtons}
            disabled={!displayPrev}
            onClick={this.prev}
            style={{ ...styles.navButton, left: '-71px' }}
            backgroundColor={themeColor}>
            <NavigationArrowBack />
          </FloatingActionButton>
          <Task
            key={pageModuleId}
            isQuiz={true}
            reader={true}
            themeColor={themeColor}
            canGrade={false}
            pageModuleId={pageModuleId}
            {...task}
            canAnswer={true}
            name={''}
            displayNextQuizQuestion={displayNext}
          />
          <FloatingActionButton
            className={classes.hideButtons}
            disabled={!displayNext}
            onClick={this.next}
            style={{ ...styles.navButton, right: '-71px' }}
            backgroundColor={themeColor}>
            <NavigationArrowForward />
          </FloatingActionButton>
        </section>
        <RaisedButton
          onClick={QuizActions.calculateTest}
          label={_l`End test`}
          style={{ marginTop: '10px', height: '50px' }}
          primary
          disabled={!testComplete}
          fullWidth
          backgroundColor='green'
        />

        <Pagination
          currentQuestion={currentQuestion}
          content={content}
          themeColor={themeColor}
        />
      </div>
    );
  }
}

class Pagination extends Component {
  render() {
    const { currentQuestion, content, themeColor } = this.props;
    return (
      <div className={classes.pagination}>
        <div className={classes.paginationDivider}>{_l`Questions`}</div>
        {content.map((q, i) => {
          return (
            <button
              key={q.id}
              onClick={() => QuizActions.setQuestion(i)}
              style={{
                ...styles.paginationBlock,
                boxShadow:
                  '0 1px 6px rgba(0, 0, 0, 0.12), 0 1px 4px rgba(0, 0, 0, 0.24)',
                transform: currentQuestion === i && 'translateY(-2px)',
                color: !q.answered ? '#000' : '#fff',
                backgroundColor: !q.answered ? '#fff' : themeColor
              }}>
              {i + 1}
            </button>
          );
        })}
      </div>
    );
  }
}

class QuizMessage extends Component {
  next() {
    QuizActions.setNextStep('QUIZ_MAIN');
  }

  render() {
    const {
      themeColor,
      title,
      description,
      hasPreviewsResult,
      settings
    } = this.props;
    let can = true;
    // if (!!settings.startDate && !!settings.endDate) {
    //   if (!dateCheck(settings.startDate, settings.endDate, new Date())) {
    //     can = false;
    //   }
    // } else if (
    //   !settings.startDate &&
    //   !!settings.endDate &&
    //   !(new Date() <= new Date(settings.endDate))
    // ) {
    //   can = false;
    // } else if (
    //   !!settings.startDate &&
    //   !settings.endDate &&
    //   !(new Date() >= new Date(settings.startDate))
    // ) {
    //   can = false;
    // }
    return (
      <div>
        <h1 className={classes.message}>{title}</h1>
        <p className={classes.message}>{description}</p>
        <div style={styles.startButtonContainer}>
          <RaisedButton
            backgroundColor={themeColor}
            style={styles.startButton}
            primary
            disabled={!can}
            onClick={this.next}
            label={can ? 'Start' : 'Test has not started yet or has ended'}
          />
          {hasPreviewsResult && (
            <RaisedButton
              backgroundColor={themeColor}
              primary
              onClick={() => QuizActions.setNextStep('QUIZ_RESULT')}
              label={_l`Result`}
            />
          )}
        </div>
      </div>
    );
  }
}

class QuizResult extends Component {
  next() {
    QuizActions.setNextStep('QUIZ_INTRO');
  }

  render() {
    const {
      title,
      score,
      total,
      content,
      data,
      hide,
      Confetti,
      enableRestartQuiz,
      themeColor
    } = this.props;
    return (
      <div>
        {typeof score === 'number' && (
          <h1 className={classes.message}>
            {title}
            <br />
            <br />
            {_l`Your score`}: {score}/{total}
          </h1>
        )}

        {!hide &&
          content.map(({ taskResults, pageModuleId, ...task }) => (
            <div key={task.id}>
              <p>{task.caption && task.caption.main}</p>
              <TaskResultList
                reader
                correctResponse={task.correctResponse}
                ListElement={RadioTaskResult}
                results={[taskResults && taskResults[taskResults.length - 1]]}
                choices={task.caption && task.caption.items}
                canGrade={false}
                taskId={task.id}
              />
              {task.caption &&
                task.caption.comment &&
                taskResults[taskResults.length - 1] &&
                !!diff(
                  taskResults[taskResults.length - 1].body.value,
                  task.correctResponse.value
                ).length && (
                  <div className={classes.comment}>
                    <h5>{_l`comment`}</h5>
                    <i>{task.caption.comment}</i>
                  </div>
                )}
            </div>
          ))}

        <div style={styles.startButtonContainer}>
          {enableRestartQuiz && (
            <RaisedButton
              style={{
                marginTop: 10
              }}
              backgroundColor={themeColor}
              primary
              onClick={() => QuizActions.setNextStep('QUIZ_MAIN')}
              label={_l`Restart`}
            />
          )}
        </div>
        {Confetti && (
          <div className={classes.confetti}>
            <Confetti height={window.innerHeight} width={window.innerWidth} />
          </div>
        )}
      </div>
    );
  }
}

export default QuizContainer;

function diff(a, b) {
  return b.filter(i => {
    return a.indexOf(i) < 0;
  });
}



// WEBPACK FOOTER //
// ./src/js/containers/QuizContainer.js